import {
  Text
} from "./chunk-GIEK627K.js";
import {
  Box_default
} from "./chunk-GDQZHQO7.js";
import {
  __objRest,
  __spreadValues
} from "./chunk-M54I523Y.js";

// packages/ui-lib/src/components/Link.tsx
import React2, {
  createContext,
  forwardRef,
  useContext
} from "react";
import cn from "classnames";

// packages/ui-lib/src/components/Link.css.ts
var color = { "default": "Link_default__1tteinu1", brand: "Link_brand__1tteinu2" };
var link = "Link__1tteinu0";

// packages/ui-lib/src/components/Link.tsx
var makeLinkComponent = (render) => ({ __forwardRef__: forwardRef(render) });
var DefaultLinkComponent = makeLinkComponent((_a, ref) => {
  var _b = _a, { children } = _b, props = __objRest(_b, ["children"]);
  return /* @__PURE__ */ React2.createElement("a", __spreadValues({
    ref
  }, props), children);
});
var LinkComponentContext = createContext(DefaultLinkComponent);
var useLinkComponent = () => {
  const linkComponent = useContext(LinkComponentContext);
  return linkComponent.__forwardRef__;
};
var useLinkClass = ({ className, color: color2 = "default" }) => cn(className, link, color[color2]);
var TextLinkButton = (_a) => {
  var _b = _a, {
    children,
    onClick
  } = _b, useLinkClassProps = __objRest(_b, [
    "children",
    "onClick"
  ]);
  return /* @__PURE__ */ React2.createElement(Text, {
    as: "span",
    role: "button",
    size: "inherit",
    tabIndex: 0,
    onClick,
    onKeyDown: (e) => {
      if (e.key === "Enter" || e.key === " ") {
        onClick();
      }
    },
    className: useLinkClass(useLinkClassProps)
  }, children);
};
var TextLinkAsSpan = (_a) => {
  var _b = _a, {
    children,
    onClick
  } = _b, useLinkClassProps = __objRest(_b, [
    "children",
    "onClick"
  ]);
  return /* @__PURE__ */ React2.createElement(Text, {
    as: "span",
    role: "link",
    size: "inherit",
    tabIndex: 0,
    onClick,
    onKeyDown: (e) => {
      if (e.key === "Enter") {
        onClick();
      }
    },
    className: useLinkClass(useLinkClassProps)
  }, children);
};
var TextLink = forwardRef((_a, forwardedRef) => {
  var _b = _a, { children, href } = _b, useLinkClassProps = __objRest(_b, ["children", "href"]);
  const Component = useLinkComponent();
  return /* @__PURE__ */ React2.createElement(Box_default, {
    className: useLinkClass(useLinkClassProps),
    asChild: true
  }, /* @__PURE__ */ React2.createElement(Component, {
    ref: forwardedRef,
    href
  }, children));
});
var RawLink = forwardRef(({ href, children }, forwardedRef) => {
  const Component = useLinkComponent();
  return /* @__PURE__ */ React2.createElement(Box_default, {
    asChild: true
  }, /* @__PURE__ */ React2.createElement(Component, {
    href,
    ref: forwardedRef
  }, children));
});

export {
  makeLinkComponent,
  LinkComponentContext,
  useLinkComponent,
  TextLinkButton,
  TextLinkAsSpan,
  TextLink,
  RawLink
};
//# sourceMappingURL=chunk-7YPVE734.js.map
